import { render } from "./내분비대사내과.vue?vue&type=template&id=72a3af2c"
import script from "./내분비대사내과.vue?vue&type=script&lang=js"
export * from "./내분비대사내과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__